// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { observer } from "mobx-react-lite";
import React from "react";

import { SARDetailsPresenter } from "../../presenters/SARDetailsPresenter";
import { MissingBadge } from "./MissingBadge";
import * as Styled from "./Summary.styles";

interface SummaryFamilySocialSupportDetailsProps {
  presenter: SARDetailsPresenter;
}

export const SummaryFamilySocialSupportDetails: React.FC<SummaryFamilySocialSupportDetailsProps> =
  observer(function SummaryFamilySocialSupportDetails({ presenter }) {
    const { fatherName, motherName, guardianName } =
      presenter.SARData?.client ?? {};

    return (
      <Styled.AssessmentTable>
        <Styled.FamilyFieldRow>
          <Styled.FamilyFieldLabel>Father:</Styled.FamilyFieldLabel>
          {fatherName || <MissingBadge />}
        </Styled.FamilyFieldRow>
        <Styled.FamilyFieldRow>
          <Styled.FamilyFieldLabel>Mother:</Styled.FamilyFieldLabel>
          {motherName || <MissingBadge />}
        </Styled.FamilyFieldRow>
        <Styled.FamilyFieldRow>
          <Styled.FamilyFieldLabel>
            Who Raised Offender:
          </Styled.FamilyFieldLabel>
          {guardianName || <MissingBadge />}
        </Styled.FamilyFieldRow>
      </Styled.AssessmentTable>
    );
  });
